<template>
<div class="page-container-content tabgroup">
  <el-tabs v-model="activeTab">
    <el-tab-pane :label="tabs.analysis.label" :name="tabs.analysis.name">
      <w-common-analysis-view :active="tabs.analysis.active" selected-type="APPLICATION" />
    </el-tab-pane>
    <el-tab-pane :label="tabs.transaction.label" :name="tabs.transaction.name">
      <w-transaction-matrix :active="tabs.transaction.active" :default-params="defaultParams" />
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty, find } from 'lodash';
import TabMixin from '@/mixins/apm/tab';
import WCommonAnalysisView from '@/views/apm/components/CommonAnalysisView';
import WTransactionMatrix from '../../transaction-matrix';

export default {
  name: 'WApplicationNode',
  components: {
    WCommonAnalysisView,
    WTransactionMatrix,
  },
  mixins: [TabMixin],
  data() {
    return {
      activeTab: null,
      tabs: {
        analysis: {
          name: 'analysis',
          label: '분석',
          active: false,
          default: true,
        },
        transaction: {
          name: 'transaction',
          label: '트랜잭션 분포',
          active: false,
        },
      },
    };
  },
  computed: {
    /**
     * 트랜잭션 분포도 로드하기위한 어플리케이션 기본 파라메터 정의
     * @return {[type]} [description]
     * @author jda
     */
    defaultParams() {
      return {
        selectedObjectType: 'application',
        selectedObjectId: this.selectedNode.applicationId,
        ...this.$store.state.apm.transactionMatrixData,
      };
    },
    /**
     * 기존 유지 탭이 없다면 default탭으로 현재 탭 변경
     * @return {[type]} [description]
     * @author jda
     */
    apmActiveTab() {
      const tabs = this.tabs;
      const currentTabName = this.$store.state.apm.mainActiveTab;
      const currentTab = tabs[currentTabName];
      return isEmpty(currentTab) ? find(tabs, 'default').name : currentTab.name;
    },
    ...mapGetters(['selectedNode']),
  },
  watch: {
    apmActiveTab: {
      immediate: true,
      handler(tabName) {
        this.activeTab = tabName;
      },
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/apm/application/node/index.vue